import React, { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { messagesFetcher } from "../api/requests";
import Cookies from "js-cookie";

const MessagesContext = createContext();

const MessagesContextProvider = ({ children }) => {
  const [messages, setMessages] = useState({});
  const [unreadMessages, setUnreadMessages] = useState({});
  const [user, setUser] = useState();

  const updateMessages = useCallback((newData) => {
    setMessages(newData);
  }, []);

  const updateUnreadMessages = useCallback((newData) => {
    setUnreadMessages(newData);
  }, []);

  useEffect(() => {
    const user = Cookies.get("vaghfnamaUser");

    if (user) {
      setUser(user);
    }
  }, []);

  useEffect(() => {
    const getMessages = async () => {
      try {
        if (user) {
          setMessages(await messagesFetcher.get());
        }
      } catch(err) {
        console.error(err);
      }
    };

    const getUnreadMessages = async () => {
      try {
        if (user) {
          setUnreadMessages(await messagesFetcher.getUdreadMessages());
        }
      } catch(err) {
        console.error(err);
      }
    };

    getMessages();
    getUnreadMessages();
  }, [user]);

  const contextValue = useMemo(() => ({
    messages,
    updateMessages,
    unreadMessages,
    updateUnreadMessages,
  }), [messages, unreadMessages])

  return (
    <MessagesContext.Provider value={contextValue}>
      {children}
    </MessagesContext.Provider>
  );
};

export { MessagesContext, MessagesContextProvider };
